let entity = "document"
export const GET_ALL =  `${process.env.REACT_APP_URL}${entity}/all`
export const GET_ALL_STATES =  `${process.env.REACT_APP_URL}${entity}/status`
export const GET_ALL_ASSIGNED =  `${process.env.REACT_APP_URL}${entity}/assigned`
export const GET_ALL_NOTASSIGNED =  `${process.env.REACT_APP_URL}${entity}/notAssigned`

export const GET_ALL_PAGETYPE =  `${process.env.REACT_APP_URL}${entity}/PageType`

export const GET_ALL_PROCCESS =  `${process.env.REACT_APP_URL}${entity}/Proccess`

export const GET_ALL_ASSIGNED_FOR_DOCUMENTID =  `${process.env.REACT_APP_URL}${entity}/AssignedAndAttachsForDocumentId`

export const GET_ALL_REJECTION_REASON =  `${process.env.REACT_APP_URL}${entity}/RejectionReasonAll`

export const GET_ALL_XML =  `${process.env.REACT_APP_URL}${entity}/transmissions`
export const GET_TYPES =  `${process.env.REACT_APP_URL}${entity}/types`
export const GET =  `${process.env.REACT_APP_URL}${entity}?id=`
export const REMOVE =  `${process.env.REACT_APP_URL}${entity}?id=`
export const POST =  `${process.env.REACT_APP_URL}${entity}/`
export const POST_SAVEASSIGNED = `${process.env.REACT_APP_URL}${entity}/saveAssigned`
export const POST_SAVEAATTACHS = `${process.env.REACT_APP_URL}${entity}/saveAttachs`
export const POST_SAVEAPPROVAL = `${process.env.REACT_APP_URL}${entity}/SaveApproval`
export const POST_SAVEREACTIVE = `${process.env.REACT_APP_URL}${entity}/Reactive` 
export const POST_DISSASOCIATE =  `${process.env.REACT_APP_URL}${entity}/disassociate`


export const PUT =  `${process.env.REACT_APP_URL}${entity}/`
// export const PUT_DISSASOCIATE =  `${process.env.REACT_APP_URL}${entity}/disassociate`

export const PUT_ASSOCIATE =  `${process.env.REACT_APP_URL}${entity}/associate`
export const PUT_OPEN =  `${process.env.REACT_APP_URL}${entity}/open`
export const PUT_REJECT =  `${process.env.REACT_APP_URL}${entity}/reject`
export const PUT_TOGGLE =  `${process.env.REACT_APP_URL}${entity}/type/toggle`
export const DOWNLOAD =  `${process.env.REACT_APP_URL}${entity}/download`
export const ALLEXPORT =  `${process.env.REACT_APP_URL}${entity}/AllExport`

